export enum DidomiVendor {
  hotjar = 'c:hotjar-9g66jcNP',
}
